export default {
    path: '/statistic',
    component: () => import(/* webpackChunkName: 'layout' */'@/views/statistic/layout/index'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '/statistic',
        name: 'statistic',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/index')
      },
      {
        path: '/statistic/enrollmentComparison',
        name: 'statisticEnrollmentComparison',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/hoursEnrollmentComparison')
      },
      //统计->项目管理-项目管理1
      {
        path: '/statistic/projectManagement/managementOne',
        name: 'projectManagementOne',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/projectManagement/managementOne')
      },
      //统计->项目管理-项目管理2
      {
        path: '/statistic/projectManagement/managementTwo',
        name: 'projectManagementTwo',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/projectManagement/managementTwo')
      },
      //统计->人员管理-工时分析->城市
      {
        path: '/statistic/personnelManagement/WorkTimeAnalysisOne',
        name: 'WorkTimeAnalysisOne',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/personnelManagement/workTimeOne')
      },
      //统计->人员管理-工时分析->人员
      {
        path: '/statistic/personnelManagement/WorkTimeAnalysisTwo',
        name: 'WorkTimeAnalysisTwo',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/personnelManagement/workTimeTwo')
      },
      //统计->人员管理-工时分析->大区
      {
        path: '/statistic/personnelManagement/WorkTimeAnalysisThree',
        name: 'WorkTimeAnalysisThree',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/personnelManagement/workTimeThree')
      },
      //统计->人员管理-工时分析->区域
      {
        path: '/statistic/personnelManagement/WorkTimeAnalysisFour',
        name: 'WorkTimeAnalysisFour',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/personnelManagement/workTimeFour')
      },
      //统计->人员管理-工时填写情况
      {
        path: '/statistic/personnelManagement/WorkTimeFillingStats',
        name: 'WorkTimeFillingStats',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/personnelManagement/fillingStats')
      },
      //统计->利润分析-项目利润核算
      {
        path: '/statistic/profitAnalysis/projectProfit',
        name: 'projectProfit',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/profitAnalysis/projectProfit')
      },
      //统计->利润分析-人员需求分析
      {
        path: '/statistic/profitAnalysis/personnelRequirement',
        name: 'personnelRequirement',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/profitAnalysis/personnelRequirement')
      },
      //统计->利润分析-城市利润表
      {
        path: '/statistic/profitAnalysis/cityProfit',
        name: 'cityProfit',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/profitAnalysis/cityProfit')
      },
      //统计->利润分析-回款统计
      {
        path: '/statistic/profitAnalysis/paymentStatistics',
        name: 'paymentStatistics',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/profitAnalysis/paymentStatistics')
      },
      //统计->实时数据-实际入组列表
      {
        path: '/statistic/realTimeData/actualEnrollment',
        name: 'actualEnrollment',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/realTimeData/actualEnrollment')
      },
      //统计->实时数据-实际访视列表
      {
        path: '/statistic/realTimeData/actualVisit',
        name: 'actualVisit',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/realTimeData/actualVisit')
      },
      //统计->实时数据-回款实时信息
      {
        path: '/statistic/realTimeData/paymentReceipt',
        name: 'paymentReceipt',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/realTimeData/paymentReceipt')
      },
      //统计->实时数据-月成本分配表
      {
        path: '/statistic/realTimeData/costAllocation',
        name: 'costAllocation',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/realTimeData/costAllocation')
      },
      //统计->项目管理-项目基础信息
      {
        path: '/statistic/projectManagement/basicInfo',
        name: 'projectBasicInfo',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/projectManagement/basicInfo')
      },
      //统计->项目管理-项目入组工时进度表
      {
        path: '/statistic/projectManagement/enrollmentProgress',
        name: 'enrollmentProgress',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/projectManagement/enrollmentProgress')
      },
      //统计->项目管理-项目回款情况
      {
        path: '/statistic/projectManagement/paymentStatus',
        name: 'projectPaymentStatus',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/projectManagement/paymentStatus')
      },
      //统计->项目管理-项目回款明细
      {
        path: '/statistic/projectManagement/paymentDetail',
        name: 'projectPaymentDetail',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/projectManagement/paymentDetail')
      },
      //统计->项目管理-分中心进度表
      {
        path: '/statistic/projectManagement/centerProgress',
        name: 'centerProgress',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/projectManagement/centerProgress')
      },
      //统计->团队架构图（SMO项目管理部）
      {
        path: '/statistic/teamOrgChart',
        name: 'teamOrgChart',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/teamOrgChart')
      },
      //统计->项目管理-项目概览
      {
        path: '/statistic/projectManagement',
        name: 'projectManagement',
        component: () => import(/* webpackChunkName: 'statistic' */'@/views/statistic/projectManagement/index')
      }
    ]
  }
